export default "__VITE_ASSET__DS$4hdU4__"